import { Routes } from '@angular/router';
import { HomePageComponent } from './Pages/home-page/home-page.component';
import { PersonalDetailsComponent } from './Pages/personal-details/personal-details.component';
import { AddressDetailsComponent } from './Pages/address-details/address-details.component';
import { FinancialDetailsComponent } from './Pages/financial-details/financial-details.component';
import { ResultPageComponent } from './Pages/result-page/result-page.component';
import { NoResultPageComponent } from './Pages/no-result-page/no-result-page.component';
import { PingyoLoanProcessComponent } from './Pages/pingyo-loan-process/pingyo-loan-process.component';

export const routes: Routes = [
  { path: '',      redirectTo: 'home', pathMatch: 'full' },
  { path: 'home',  component: HomePageComponent },
  { path: 'personal', component: PersonalDetailsComponent},
  { path: 'address', component: AddressDetailsComponent },
  { path: 'financial', component: FinancialDetailsComponent},
  { path: 'result', component: ResultPageComponent },
  { path: 'searching-loans', component:PingyoLoanProcessComponent},
  { path: 'noresult', component:NoResultPageComponent},
];
